<template>
    <div class="flex items-center space-x-1">
        <input
            v-for="size of sizes"
            type="number"
            :placeholder="ucwords(size)"
            @change="updateSize(size, $event.target.value)"
            class="border-2 border-dark p-1 rounded focus:ring-0 placeholder:text-black block w-full h-10"
        />
    </div>
</template>

<script>
import Strings from '@/Mixins/Utilities/Strings';

export default {
    components: {},
    emits: ['update:modelValue'],
    mixins: [Strings],
    props: {
        modelValue: Object
    },
    data() {
        return {
            sizes: ['width', 'profile', 'rim']
        }
    },
    methods: {
        updateSize(property, value) {
            const size = {...this.modelValue};

            size[property] = value;

            this.$emit('update:modelValue', size);
        }
    }
}
</script>

<style scoped>

</style>
